export default __webpack_public_path__ + "static/Wallop-Medium-a4c32fc6a9c317ca9efab00b97267cd9.woff2";